/* storybook-check-ignore */
import { FC, useState } from 'react';

import { CONSUMER_URL } from 'components/globals';
import { useTrackProperty } from 'components/marketplace/helpers';
import { determinePropertyActionability } from 'components/marketplace/helpers/propertyActionability';
import { TOUR_ACTION_TEXT } from 'components/self-tour/hooks/useTouring';

import { useObservability } from 'helpers/observability';

import { FloatingCTA } from './PropertySection/FloatingCTA';
import { TourWithAgentModal } from './PropertySection/TourWithAgentModal';
import { PropertyDetailsType } from './types';

interface FooterCTAProps {
  property: PropertyDetailsType;
  isVisible?: boolean;
}

export const FooterCTA: FC<FooterCTAProps> = ({ property, isVisible = true }) => {
  const { trackProperty } = useTrackProperty();
  const { trackJourneyEvent } = useObservability();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const { isActionable, tourKind } = determinePropertyActionability(property);

  // Only show FooterCTA for actionable properties
  if (!isActionable || !tourKind) {
    return null;
  }

  const handleCtaClick = () => {
    if (tourKind === 'selfTour') {
      trackProperty('property-self-tour', 'marketplace-pdp-footer-cta');
      trackJourneyEvent('marketplaceProperty', 'tourBookingStart', {
        addressUuid: property.addressToken,
        placement: 'footer',
      });

      window.open(
        `${CONSUMER_URL}/dashboard/buy/tour?id=${property.addressToken}`,
        '_blank',
        'noopener',
      );
    } else {
      setIsDialogOpen(true);
    }
  };

  const handleClose = () => {
    setIsDialogOpen(false);
  };

  return (
    <>
      <FloatingCTA
        ctaText={TOUR_ACTION_TEXT[tourKind]}
        onClickCta={handleCtaClick}
        isLiked={property.isLiked}
        onClickReaction={property.onClickReaction}
        variant={tourKind === 'tourWithAgent' ? 'secondary' : 'primary'}
        isVisible={isVisible}
      />
      {tourKind === 'tourWithAgent' && (
        <TourWithAgentModal property={property} isOpen={isDialogOpen} onClose={handleClose} />
      )}
    </>
  );
};
